module.exports = __webpack_public_path__ + "media/patterns/yellow-dots-a7497be5.svg";